import React from "react";

import { PromoImageCardsBlock } from "@reactivated";

import { HLevel } from "../Headings";
import { ThemedModule } from "../ThemedModule";
import { SingleCard } from "./Cards/SingleCard";
import { TwoUpCards } from "./Cards/TwoUpCards";

import styles from "./PromoImageCards.module.scss";

interface PromoImageCardsProps {
    value: PromoImageCardsBlock;
}

export const VARIANT = {
    IMAGE_FILL: "image-fill",
    IMAGE_BLOCK: "image-block",
} as const;

const LAYOUT = {
    SINGLE: "single",
    TWO_UP: "2-up",
} as const;

export const PromoImageCards = ({ value }: PromoImageCardsProps) => {
    return (
        <ThemedModule theme={value.module_theme}>
            <HLevel>
                <section className={styles.root}>
                    {value.layout === LAYOUT.SINGLE && value.cards?.[0] ? (
                        <SingleCard card={value.cards[0]} />
                    ) : value.layout === LAYOUT.TWO_UP && value.cards ? (
                        <TwoUpCards cards={value.cards} />
                    ) : null}
                </section>
            </HLevel>
        </ThemedModule>
    );
};
